var riot = require('riot');
module.exports = riot.tag2('router', '<top-bar></top-bar> <view tag="{view}-view" params="{params}"></view>', '', '', function(opts) {
        this.mixin(require('mixins/router').default);
});